import React from "react";

import { cn } from "@utilities/helper";

const ServicesIcon = ({ className }: { className?: string }) => (
  <svg
    className={cn("rtl:-scale-x-100", className)}
    viewBox="0 0 164 135"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6843 134.495C14.0123 134.495 13.4363 134.111 13.0523 133.631C11.9003 131.903 3.06831 102.047 0.188306 95.8066C-0.291694 94.8466 0.188306 93.6946 1.14831 93.3106C20.1563 84.3826 26.1083 78.5266 33.0203 71.6146L34.2683 70.3666C37.7243 67.0066 46.8443 57.9826 57.1163 65.5666C77.1803 80.2546 90.2363 82.3666 94.9403 82.5586C97.3403 82.7506 104.636 83.0386 105.788 87.7426C106.748 91.9666 101.852 96.3826 97.9163 99.2626C112.124 100.223 119.516 95.1346 127.58 89.5666C130.556 87.5506 133.532 85.4386 137.084 83.5186C141.212 81.3106 160.028 76.0306 163.292 80.5426C164.06 81.5986 164.444 83.6146 161.468 86.3986C121.244 123.935 97.9163 126.431 89.7563 125.759C85.0523 125.375 79.6763 124.031 74.1083 122.687C64.1243 120.191 53.7563 117.599 44.9243 119.711C31.6763 123.359 15.8363 134.015 15.7403 134.111C15.4523 134.303 15.0683 134.495 14.6843 134.495Z"
      fill="inherit"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M72.9559 56.928C72.5719 56.928 72.1879 56.736 71.8999 56.544C71.3239 56.16 71.0359 55.392 71.1319 54.72L73.5319 36.672L60.9559 23.52C60.4759 23.04 60.2839 22.272 60.4759 21.6C60.7639 20.928 61.3399 20.448 62.0119 20.352L79.8679 17.088L88.5079 1.056C88.8919 0.384 89.4679 0 90.2359 0C90.9079 0 91.5799 0.384 91.8679 1.056L100.508 17.088L118.46 20.352C119.132 20.448 119.708 20.928 119.9 21.6C120.092 22.272 119.996 23.04 119.516 23.52L106.94 36.672L109.34 54.72C109.436 55.392 109.148 56.16 108.572 56.544C107.996 56.928 107.228 57.024 106.556 56.736L90.2359 48.768L73.8199 56.736C73.5319 56.832 73.2439 56.928 72.9559 56.928Z"
      fill="inherit"
    />
  </svg>
);

export default ServicesIcon;
